import { $onload } from '../../../../utils/dom.ts';
import formSubmitHandler from '../../../form-submit-handlers/index.ts';

$onload(
    '.view-components-blocks-NewsletterSignup',
    HTMLElement,
    ($el, { $OrThrow }) => {
        formSubmitHandler({
            handler: JSON.parse($el.dataset.handler || ''),
            $form: $OrThrow('__form', HTMLFormElement),
            $message: $OrThrow('__message', HTMLElement),
        });
    },
);
